<template>
  <!-- Sidebar derecho flotante. De momento es SOLO el chrome:
       cabecera con pestañas + fijar (pin) + cerrar, y un cuerpo placeholder. El
       contenido real de cada pestaña se definirá más adelante. -->
  <div class="epc-sidebar" :class="{ 'is-docked': docked }">
    <div class="epc-sidebar-header">
      <!-- Pestañas (por ahora solo cambian el estado visual activo) -->
      <div class="epc-sidebar-tabs">
        <button v-for="tab in tabs" :key="tab.key"
          class="epc-sidebar-tab"
          :class="{ 'is-active': tab.key === activeTab }"
          :aria-label="tab.key"
          @click="_SelectTab(tab)">
          <b-icon pack="fas" :icon="tab.icon" size="is-small"></b-icon>
        </button>
      </div>

      <div class="epc-sidebar-header-actions">
        <!-- Fijar (pin): acopla el panel y reduce el lienzo. -->
        <button class="epc-sidebar-icon-btn"
          :class="{ 'is-active': docked }"
          :aria-label="$t('pin')"
          @click="_TogglePin">
          <b-icon pack="fas" icon="thumbtack" size="is-small"></b-icon>
        </button>

        <!-- Cerrar -->
        <button class="epc-sidebar-icon-btn"
          :aria-label="$t('close')"
          @click="$emit('epc-close', true)">
          <b-icon pack="fas" icon="xmark" size="is-small"></b-icon>
        </button>
      </div>
    </div>

    <div class="epc-sidebar-divider"></div>

    <!-- Cuerpo: la pestaña 'info' muestra el contenido del parque; el resto, placeholder. -->
    <div class="epc-sidebar-body">
      <ViewerInfoContent v-if="activeTab === 'info' && projectId"
        :project-id="projectId" :hovered-block-id="hoveredBlockId"
        :focused-block-id="focusedBlockId" :active-layer="activeLayer" />
      <div v-else class="epc-sidebar-empty">
        <b-icon pack="fas" icon="layer-group" custom-size="fa-2x" class="epc-sidebar-empty-icon"></b-icon>
        <p class="epc-sidebar-empty-text">{{ $t('empty_panel') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import ViewerInfoContent from "../panels/ViewerInfoContent.vue"

export default {
  name: "ViewerSidebarDesign",

  components: { ViewerInfoContent },

  props: {
    projectId: { type: Number, default: null },
    hoveredBlockId: { type: [Number, String], default: null },
    focusedBlockId: { type: [Number, String], default: null }, // bloque enfocado (foco) → su detalle en "info"
    activeLayer: { type: String, default: null }, // vista/capa actual → se resalta en el detalle
    docked: { type: Boolean, default: false }, // fijado (acoplado) desde la página
  },

  data() {
    return {
      // Pestañas de la cabecera. 'info' muestra la info del parque en el body; el resto
      // (buscar/biblioteca/chat/stats) se ocultan de momento hasta tener su contenido.
      tabs: [
        { key: 'info', icon: 'circle-info' },
        // { key: 'search', icon: 'magnifying-glass' },
        // { key: 'library', icon: 'book-open' },
        // { key: 'comments', icon: 'comment' },
        // { key: 'stats', icon: 'chart-line' },
      ],
      activeTab: 'info',
    };
  },

  watch: {
    // Al enfocar un bloque (doble click en el visor) saltamos a la pestaña "info"
    // para mostrar su detalle.
    focusedBlockId(id) {
      if (id != null) this.activeTab = 'info';
    },
  },

  methods: {
    _SelectTab(tab) {
      this.activeTab = tab.key;
    },
    _TogglePin() {
      this.$emit('epc-pin', !this.docked);
    },
  },
}
</script>

<style scoped>
.epc-sidebar {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 340px;
  max-width: 85vw;
  background-color: #ffffff;
  border-left: 1px solid #e3e3e8;
  box-shadow: -2px 0 8px 0 rgba(0, 0, 0, 0.08);
  z-index: 7;
  display: flex;
  flex-direction: column;
}

/* Fijado (pin): sale del overlay y se acopla al flujo (hermano flex del área del visor),
   así el lienzo se encoge en vez de quedar tapado. */
.epc-sidebar.is-docked {
  position: relative;
  top: auto;
  right: auto;
  bottom: auto;
  height: 100%;
  flex: 0 0 340px;
  z-index: auto;
}

.epc-sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 12px;
}

.epc-sidebar-tabs {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 4px;
  border: 1px solid #e9e9ef;
  border-radius: 10px;
  background-color: #ffffff;
}

.epc-sidebar-tab {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 30px;
  border: none;
  border-radius: 8px;
  background-color: transparent;
  color: #495057;
  cursor: pointer;
}

.epc-sidebar-tab:hover {
  background-color: #f4f4f6;
}

.epc-sidebar-tab.is-active {
  background-color: #6965db;
  color: #ffffff;
}

.epc-sidebar-header-actions {
  display: flex;
  align-items: center;
  gap: 4px;
}

.epc-sidebar-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background-color: transparent;
  color: #495057;
  cursor: pointer;
}

.epc-sidebar-icon-btn:hover {
  background-color: #f4f4f6;
}

.epc-sidebar-icon-btn.is-active {
  color: #6965db;
}

.epc-sidebar-divider {
  height: 1px;
  margin: 0 12px;
  background-color: #ececf1;
}

.epc-sidebar-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 16px;
}

.epc-sidebar-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  text-align: center;
  color: #9a9aa2;
}

.epc-sidebar-empty-icon {
  color: #c7c7d1;
  margin-bottom: 8px;
}

.epc-sidebar-empty-text {
  font-size: 13px;
}
</style>
